module.exports = __webpack_public_path__ + "static/20230619_113-18523a7f8a5914467e9f48fd0b7f9edf.jpg";